export const GET_ADVERTISEMENTS_REQUEST = 'GET_ADVERTISEMENTS_REQUEST'
export const GET_ADVERTISEMENTS = 'GET_ADVERTISEMENTS'

export const GET_ADVERTISEMENT_REQUEST = 'GET_ADVERTISEMENT_REQUEST'
export const GET_ADVERTISEMENT = 'GET_ADVERTISEMENT'

export const CREATE_ADVERTISEMENT_REQUEST = 'CREATE_ADVERTISEMENT_REQUEST'
export const CREATE_ADVERTISEMENT = 'CREATE_ADVERTISEMENT'

export const UPDATE_ADVERTISEMENT_REQUEST = 'UPDATE_ADVERTISEMENT_REQUEST'
export const UPDATE_ADVERTISEMENT = 'UPDATE_ADVERTISEMENT'

export const DELETE_ADVERTISEMENT_REQUEST = 'DELETE_ADVERTISEMENT_REQUEST'
export const DELETE_ADVERTISEMENT = 'DELETE_ADVERTISEMENT'

export const GET_ADVERTISEMENTS_REQUEST_PENDING = 'GET_ADVERTISEMENTS_REQUEST_PENDING'
export const GET_ADVERTISEMENTS_REQUEST_SUCCESS = 'GET_ADVERTISEMENTS_REQUEST_SUCCESS'
export const GET_ADVERTISEMENTS_REQUEST_ERROR = 'GET_ADVERTISEMENTS_REQUEST_ERROR'

export const CHANGE_ADVERTISEMENTS_REQUEST_PENDING = 'CHANGE_ADVERTISEMENTS_REQUEST_PENDING'
export const CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS = 'CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS'
export const CHANGE_ADVERTISEMENTS_REQUEST_ERROR = 'CHANGE_ADVERTISEMENTS_REQUEST_ERROR'
